import { render, staticRenderFns } from "./AssignedPermissionsList.vue?vue&type=template&id=814a26ea&scoped=true"
import script from "./AssignedPermissionsList.vue?vue&type=script&lang=js"
export * from "./AssignedPermissionsList.vue?vue&type=script&lang=js"
import style0 from "./AssignedPermissionsList.vue?vue&type=style&index=0&id=814a26ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814a26ea",
  null
  
)

export default component.exports